export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [{
      index: 0,
      label: 'Accueil',
      url: '/',
      labelIcon: 'HomeIcon',
      highlightAction: false
    },
    {
      index: 1,
      label: 'Liste des contacts',
      url: '/contacts/listing',
      labelIcon: 'UsersIcon',
      highlightAction: false
    },
    {
      index: 2,
      label: 'Ajouter un contact',
      url: '/contacts/ajouter',
      labelIcon: 'UserPlusIcon',
      highlightAction: false
    },
    {
      index: 3,
      label: 'Liste des dossiers clients',
      url: '/dossiers/listing',
      labelIcon: 'FolderIcon',
      highlightAction: false
    },
    {
      index: 4,
      label: 'Créer un dossier client',
      url: '/dossiers/ajouter',
      labelIcon: 'FolderPlusIcon',
      highlightAction: false
    },
    {
      index: 4,
      label: 'Documents clients',
      url: '/documents/listing',
      labelIcon: 'FileTextIcon',
      highlightAction: false
    },
    {
      index: 5,
      label: 'Ajouter un fichier',
      url: '/documents/ajouter',
      labelIcon: 'FilePlusIcon',
      highlightAction: false
    },
  ]
}